<script setup lang="ts">
defineProps<{
  filled?: boolean;
}>();
</script>

<template>
  <svg v-if="!filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m18 22.7-6-6-6 6V2h12v20.7Zm-6-7.4 5 5V3H7v17.3l5-5Z" /></svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="m18 22.7-6-6-6 6V2h12v20.7Z"/></svg>
</template>
